module.exports = __webpack_public_path__ + "img/sHighwayB_193x205.0d7ccfdc.png";